import { Button, ButtonVariant } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../translations';

type MedicalProfileButtonProps = {
   readonly onClick: VoidFunction;
};

export const MedicalProfileButton = (props: MedicalProfileButtonProps): JSX.Element => (
   <Button
      testId={'medicalProfile'}
      label={appointmentsTranslationKeys.medicalProfile.add}
      variant={ButtonVariant.SECONDARY}
      compact
      onClick={props.onClick}
   />
);
